<ng-container *ngIf="extractTwitterName()" >
<ngx-twitter-timeline [source]="{sourceType: 'profile', screenName: extractTwitterName()}" [options]="{height: '350'}">
</ngx-twitter-timeline>
</ng-container>
